import React from 'react';
import './NotFound.css';

const NotFound = () => {
    return (
        <div className='container'>
            <div className="container-fluid">
                <img className="img-fluid img-class" src="https://colorlib.com/wp/wp-content/uploads/sites/2/404-error-template-3.png" alt="" />
            </div>
        </div>
            
    );
};

export default NotFound;